var React = require('react');

function ArrowswiperInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#888888","d":"M11.3 19.3q-.275-.275-.288-.7q-.012-.425.263-.7l4.9-4.9H5q-.425 0-.713-.288Q4 12.425 4 12t.287-.713Q4.575 11 5 11h11.175l-4.9-4.9q-.275-.275-.263-.7q.013-.425.288-.7q.275-.275.7-.275q.425 0 .7.275l6.6 6.6q.15.125.213.312q.062.188.062.388t-.062.375q-.063.175-.213.325l-6.6 6.6q-.275.275-.7.275q-.425 0-.7-.275Z"}));
}

ArrowswiperInline.defaultProps = {"aria-hidden":"true","role":"img","className":"iconify iconify--material-symbols","width":"48","height":"48","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 24 24"};

module.exports = ArrowswiperInline;

ArrowswiperInline.default = ArrowswiperInline;
